export default [
  { lg: 4, title: 'Action' },
  { lg: 4, title: 'Rule Name' },
  { lg: 3, title: 'Applies to?' }
];
